import React from 'react';
import { Capacitor } from '@capacitor/core';

const IOS_STORE_URL = 'https://apps.apple.com/app/id6759229618';
const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.gulfcoasthackers.league';

function getStoreUrl() {
  const platform = Capacitor.getPlatform();
  return platform === 'ios' ? IOS_STORE_URL : ANDROID_STORE_URL;
}

async function openStore() {
  try {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url: getStoreUrl() });
  } catch {
    window.open(getStoreUrl(), '_blank');
  }
}

export default function AppUpdateModal({ forceUpdate, latestVersion, onDismiss }) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[99999] p-4">
      <div className="bg-white dark:bg-navy-900 rounded-xl p-8 max-w-[360px] w-full text-center shadow-glass">
        <h2 className="mb-3 text-xl font-bold text-gray-900 dark:text-white">
          Update Available
        </h2>
        <p className="mb-6 text-[0.95rem] leading-relaxed text-gray-600 dark:text-gray-300">
          {forceUpdate
            ? `A required update (v${latestVersion}) is available. Please update to continue using the app.`
            : `A new version (v${latestVersion}) is available with improvements and bug fixes.`}
        </p>
        <button
          className="w-full py-3 border-none rounded-lg bg-forest-950 dark:bg-forest-700 text-white text-base font-semibold cursor-pointer hover:bg-forest-900 dark:hover:bg-forest-600 transition-colors"
          onClick={openStore}
        >
          Update Now
        </button>
        {!forceUpdate && (
          <button
            className="w-full py-3 border-none rounded-lg bg-transparent text-gray-500 dark:text-gray-400 text-sm cursor-pointer mt-2 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
            onClick={onDismiss}
          >
            Not Now
          </button>
        )}
      </div>
    </div>
  );
}
